// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    PatientFinderRequest,
    PatientFinderRequestSearchRequest,
    PatientFinderResultSearchRequest,
    PatientV1PatientV1PatientFinderDefaultResponse,
    PatientV1PatientV1PatientFinderRequestSearchDefaultResponse,
    PatientV1PatientV1PatientFinderResultSearchDefaultResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePatientApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param patientFinderRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientV1PatientFinder (patientFinderRequest: PatientFinderRequest, xProgramId?: string): Promise<AxiosResponse<PatientV1PatientV1PatientFinderDefaultResponse>> {
        const _url_ = '/edge/patient/v1/PatientFinder';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientFinderRequest' is not null or undefined
        if (patientFinderRequest === null || patientFinderRequest === undefined) {
            throw new Error('Required parameter patientFinderRequest was null or undefined when calling patientV1PatientFinder.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientFinderRequest, "PatientFinderRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientV1PatientV1PatientFinderDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientV1PatientV1PatientFinderDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientFinderRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientV1PatientFinderRequestSearch (patientFinderRequestSearchRequest: PatientFinderRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<PatientV1PatientV1PatientFinderRequestSearchDefaultResponse>> {
        const _url_ = '/edge/patient/v1/PatientFinderRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientFinderRequestSearchRequest' is not null or undefined
        if (patientFinderRequestSearchRequest === null || patientFinderRequestSearchRequest === undefined) {
            throw new Error('Required parameter patientFinderRequestSearchRequest was null or undefined when calling patientV1PatientFinderRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientFinderRequestSearchRequest, "PatientFinderRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientV1PatientV1PatientFinderRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientV1PatientV1PatientFinderRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientFinderResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientV1PatientFinderResultSearch (patientFinderResultSearchRequest: PatientFinderResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<PatientV1PatientV1PatientFinderResultSearchDefaultResponse>> {
        const _url_ = '/edge/patient/v1/PatientFinderResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientFinderResultSearchRequest' is not null or undefined
        if (patientFinderResultSearchRequest === null || patientFinderResultSearchRequest === undefined) {
            throw new Error('Required parameter patientFinderResultSearchRequest was null or undefined when calling patientV1PatientFinderResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientFinderResultSearchRequest, "PatientFinderResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientV1PatientV1PatientFinderResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientV1PatientV1PatientFinderResultSearchDefaultResponse");
        }
        return response;
    }
}
